"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var date_range_selector_component_1 = require("./date/date-range-selector.component");
var data_graph_component_1 = require("./chart/linechart/data.graph.component");
var data_graph_component_2 = require("./chart/barchart/data.graph.component");
var material_module_1 = require("../material.module");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var platform_browser_1 = require("@angular/platform-browser");
var core_2 = require("@ngx-translate/core");
var NanoCommonModule = /** @class */ (function () {
    function NanoCommonModule() {
    }
    NanoCommonModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                material_module_1.MaterialModule,
                common_1.CommonModule,
                forms_1.FormsModule,
                platform_browser_1.BrowserModule,
                core_2.TranslateModule
            ],
            declarations: [
                date_range_selector_component_1.DateRangeSelectorComponent,
                data_graph_component_1.DataGraphComponent,
                data_graph_component_2.BarChartComponent
            ],
            exports: [
                date_range_selector_component_1.DateRangeSelectorComponent,
                data_graph_component_1.DataGraphComponent,
                data_graph_component_2.BarChartComponent
            ]
        })
    ], NanoCommonModule);
    return NanoCommonModule;
}());
exports.NanoCommonModule = NanoCommonModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbW1vbi5tb2R1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQXlDO0FBQ3pDLHNGQUFrRjtBQUNsRiwrRUFBNEU7QUFDNUUsOEVBQTBFO0FBQzFFLHNEQUFvRDtBQUNwRCwwQ0FBK0M7QUFDL0Msd0NBQTZDO0FBQzdDLDhEQUEwRDtBQUMxRCw0Q0FBc0Q7QUFxQnREO0lBQUE7SUFDQSxDQUFDO0lBRFksZ0JBQWdCO1FBbkI1QixlQUFRLENBQUM7WUFDTixPQUFPLEVBQUU7Z0JBQ0wsZ0NBQWM7Z0JBQ2QscUJBQVk7Z0JBQ1osbUJBQVc7Z0JBQ1gsZ0NBQWE7Z0JBQ2Isc0JBQWU7YUFDbEI7WUFDRCxZQUFZLEVBQUU7Z0JBQ1YsMERBQTBCO2dCQUMxQix5Q0FBa0I7Z0JBQ2xCLHdDQUFpQjthQUNwQjtZQUNELE9BQU8sRUFBRztnQkFDTiwwREFBMEI7Z0JBQzFCLHlDQUFrQjtnQkFDbEIsd0NBQWlCO2FBQ3BCO1NBQ0osQ0FBQztPQUNXLGdCQUFnQixDQUM1QjtJQUFELHVCQUFDO0NBQUEsQUFERCxJQUNDO0FBRFksNENBQWdCIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/common/common.module.ts
// module id = 616
// module chunks = 0